import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import MenuItem from "./MenuItem";
import MenuItemForm from "./MenuItemForm";
import ImageUpload from "../../../forms/ImageUpload";

const Menu = () => {
  const [menuIsLoading, setMenuIsLoading] = useState(true);
  const [menuData, setMenuData] = useState({});
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [isImageUpdateFormVisible, setIsImageUpdateFormVisible] = useState(false);
  const [imageUploadDetails, setImageUploadDetails] = useState({});

  const params = useParams();

  const fetchMenuData = async () => {
    setMenuIsLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/menu/${params.businessId}/${params.menuId}`,
      { credentials: "include", method: "GET" }
    );
    const data = await response.json();
    if (response.ok) {
      setMenuData(data);
      setMenuIsLoading(false);
    }
  };

  const deleteMenuItem = async (menuItemId) => {
    if (!window.confirm("Are you sure you want to delete this menu item?")) return;
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/menuitem/${params.businessId}/${params.menuId}/${menuItemId}`,
      { credentials: "include", method: "DELETE" }
    );
    if (response.ok) fetchMenuData();
  };

  const changeImage = (type, menuItemId, name) => {
    setImageUploadDetails({ type, menuItemId, name });
    setIsImageUpdateFormVisible(true);
  };

  const closeUploadForm = () => setIsImageUpdateFormVisible(false);

  useEffect(() => {
    fetchMenuData();
  }, []);

  if (menuIsLoading) {
    return (
      <div style={{ background: "var(--cream)", minHeight: "100vh", padding: "28px" }}>
        <div style={{ maxWidth: "900px", margin: "0 auto", color: "var(--ink-muted)", fontSize: "14px" }}>
          Loading…
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: "var(--cream)", minHeight: "100vh", padding: "28px 28px 72px" }}>
      <div style={{ maxWidth: "900px", margin: "0 auto" }}>

        {/* Back link */}
        <Link
          to="/account/allergen-menus"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            fontSize: "13px",
            fontWeight: 500,
            color: "var(--brand)",
            textDecoration: "none",
            marginBottom: "20px",
          }}
        >
          ← Allergen Menus
        </Link>

        {/* Page header */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: "16px",
            marginBottom: "24px",
          }}
        >
          <div>
            <p
              style={{
                fontSize: "11px",
                fontWeight: 700,
                color: "var(--ink-muted)",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                marginBottom: "4px",
              }}
            >
              Menu Builder
            </p>
            <h1
              style={{
                fontFamily: "'DM Serif Display', serif",
                fontSize: "26px",
                color: "var(--ink)",
                margin: "0 0 4px",
              }}
            >
              {menuData.menuName}
            </h1>
            <p style={{ fontSize: "13px", color: "var(--ink-muted)", margin: 0 }}>
              Add to or remove menu items below.
            </p>
          </div>

          {!showCreateForm && (
            <button
              onClick={() => setShowCreateForm(true)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 16px",
                borderRadius: "8px",
                fontSize: "13px",
                fontWeight: 600,
                background: "var(--brand)",
                color: "white",
                border: "none",
                cursor: "pointer",
                flexShrink: 0,
                fontFamily: "inherit",
              }}
            >
              + Menu Item
            </button>
          )}
        </div>

        {/* Menu items */}
        <div style={{ marginBottom: "16px" }}>
          {menuData.menuItems?.length > 0 ? (
            menuData.menuItems.map((menuItem) => (
              <MenuItem
                key={menuItem._id}
                menuItem={menuItem}
                fetchMenuData={fetchMenuData}
                deleteMenuItem={deleteMenuItem}
                changeImage={changeImage}
              />
            ))
          ) : (
            !showCreateForm && (
              <div
                style={{
                  background: "var(--white)",
                  border: "1px solid var(--border)",
                  borderRadius: "12px",
                  padding: "40px 32px",
                  textAlign: "center",
                  boxShadow: "var(--shadow)",
                }}
              >
                <p style={{ fontSize: "14px", color: "var(--ink-muted)" }}>
                  No menu items yet. Add your first item above.
                </p>
              </div>
            )
          )}
        </div>

        {/* Create form */}
        {showCreateForm && (
          <MenuItemForm
            businessId={params.businessId}
            menuId={params.menuId}
            fetchMenuData={fetchMenuData}
            setShowCreateForm={setShowCreateForm}
          />
        )}
      </div>

      {/* Image upload overlay */}
      {isImageUpdateFormVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start z-50 overflow-y-auto">
          <div className="p-4 m-auto bg-white">
            <ImageUpload
              imageUploadDetails={imageUploadDetails}
              closeUploadForm={closeUploadForm}
              fetchMenuData={fetchMenuData}
              businessId={params.businessId}
              menuId={params.menuId}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Menu;
